import { StateStorage } from 'zustand/middleware'
import { createStore } from '..'
import {
  ARB_CHAIN_ID,
  BASE_CHAIN_ID,
  BNB_CHAIN_ID,
  ETH_CHAIN_ID,
  HYPEREVM_CHAIN_ID,
} from '../../constants/business'

interface EVMChainsState {
  userEVMChains: number[]
  addChain: (chain: number) => void
  removeChain: (chain: number) => void
}

export const createUserEVMChainsStore = (storage: StateStorage) =>
  createStore<EVMChainsState>(
    storage,
    (set, get) => ({
      userEVMChains: [ETH_CHAIN_ID, BNB_CHAIN_ID, BASE_CHAIN_ID, ARB_CHAIN_ID, HYPEREVM_CHAIN_ID],
      addChain: (chain) => {
        const { userEVMChains } = get()
        if (!userEVMChains.some((c) => c === chain)) {
          set({ userEVMChains: [...userEVMChains, chain] })
        }
      },
      removeChain: (chain) => {
        const { userEVMChains } = get()
        set({ userEVMChains: userEVMChains.filter((c) => c !== chain) })
      },
    }),
    {
      persist: {
        name: 'userEVMChains',
        version: 1,
        // v1 enables HyperEVM by default. Append it for existing users
        // without touching the chains they have toggled.
        migrate: (persistedStateUnchecked) => {
          const persistedState = persistedStateUnchecked as EVMChainsState

          return {
            ...persistedState,
            userEVMChains: persistedState.userEVMChains.includes(HYPEREVM_CHAIN_ID)
              ? persistedState.userEVMChains
              : [...persistedState.userEVMChains, HYPEREVM_CHAIN_ID],
          }
        },
      },
    }
  )
